import { computed } from '@vue/composition-api';
import { useCommonColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-common-columns';
import { useAcceptanceColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-acceptance-columns';
export const useOfferObjectColumns = (ctx, offer, shownYear) => {
    const { commonColumns } = useCommonColumns(ctx, {
        offer,
        useOfferObjectDetails: true,
        shownYear,
    });
    const { acceptanceColumns } = useAcceptanceColumns(ctx, {
        offer,
        decisionSelectId: 'offer-decision-select',
    });
    const columns = computed(() => {
        return [
            ...commonColumns.value,
            ...(offer.isApprovalRequired ? acceptanceColumns : []),
        ];
    });
    return { columns };
};
